(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(section) {
    const track = section.querySelector('[data-featured-slider-track]');
    const prevBtn = section.querySelector('[data-featured-slider-prev]');
    const nextBtn = section.querySelector('[data-featured-slider-next]');
    const progress = section.querySelector('[data-featured-slider-progress]');
    const progressBar = section.querySelector('[data-featured-slider-progress-bar]');

    if (!track) return;

    function getStep() {
      const firstItem = track.querySelector('.featured-slider__item');
      if (!firstItem) return 0;
      const itemRect = firstItem.getBoundingClientRect();
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return itemRect.width + gap;
    }

    function isScrollable() {
      return track.scrollWidth - track.clientWidth > 1;
    }

    function updateUI() {
      const scrollable = isScrollable();
      if (progress) progress.classList.toggle('is-hidden', !scrollable);
      if (prevBtn) prevBtn.classList.toggle('is-hidden', !scrollable);
      if (nextBtn) nextBtn.classList.toggle('is-hidden', !scrollable);

      if (!scrollable) {
        if (progressBar) progressBar.style.width = '0%';
        if (prevBtn) prevBtn.disabled = true;
        if (nextBtn) nextBtn.disabled = true;
        return;
      }

      const max = track.scrollWidth - track.clientWidth;
      const ratio = max > 0 ? track.scrollLeft / max : 0;
      if (progressBar) progressBar.style.width = (ratio * 100) + '%';

      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 1;
    }

    let rafId = null;
    function onScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        updateUI();
        rafId = null;
      });
    }

    function scrollByStep(direction) {
      const step = getStep();
      if (!step) return;
      track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    const autoplay = section.dataset.autoplay === 'true';
    const loop = section.dataset.loop === 'true';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const AUTOPLAY_INTERVAL_MS = 5000;
    let autoplayTimer = null;

    function startAutoplay() {
      if (!autoplay || reduceMotion || !isScrollable()) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        if (!isScrollable()) return;
        const max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= max - 1) {
          if (loop) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            stopAutoplay();
          }
        } else {
          scrollByStep(1);
        }
      }, AUTOPLAY_INTERVAL_MS);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByStep(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByStep(1); });
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateUI);

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    track.addEventListener('touchstart', stopAutoplay, { passive: true });

    updateUI();
    startAutoplay();

    return function cleanup() {
      stopAutoplay();
      track.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', updateUI);
    };
  }

  function initAll() {
    document.querySelectorAll('[id^="featured-slider-"]').forEach(function (section) {
      if (section.dataset.featuredSliderInit === '1') return;
      const cleanup = initSlider(section);
      section.dataset.featuredSliderInit = '1';
      section._featuredSliderCleanup = cleanup;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[id^="featured-slider-"]') || (event.target.id && event.target.id.indexOf('featured-slider-') === 0 ? event.target : null);
    if (section && section.dataset.featuredSliderInit !== '1') {
      const cleanup = initSlider(section);
      section.dataset.featuredSliderInit = '1';
      section._featuredSliderCleanup = cleanup;
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const section = event.target.querySelector('[id^="featured-slider-"]') || (event.target.id && event.target.id.indexOf('featured-slider-') === 0 ? event.target : null);
    if (section && typeof section._featuredSliderCleanup === 'function') {
      section._featuredSliderCleanup();
      section._featuredSliderCleanup = null;
      section.dataset.featuredSliderInit = '';
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
